import React, { useState } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import './AkademisyenTopluEkle.css';

const AutoAssignCourses = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const [replaceActiveYear, setReplaceActiveYear] = useState(false);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
      setSelectedFile(file);
      setUploadResult(null);
    } else {
      alert('Lütfen geçerli bir Excel dosyası (.xlsx veya .xls) seçin.');
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
        setSelectedFile(file);
        setUploadResult(null);
      } else {
        alert('Lütfen geçerli bir Excel dosyası (.xlsx veya .xls) seçin.');
      }
    }
  };

  const handleUpload = async (mode = 'preview') => {
    if (!selectedFile) {
      alert('Lütfen bir dosya seçin.');
      return;
    }

    setIsUploading(true);
    setUploadResult(null);
    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('mode', mode);
    formData.append('replace_active_year', String(replaceActiveYear));
    if (mode === 'apply') {
      formData.append('confirmation', replaceActiveYear
        ? 'AKTIF_YIL_DERS_PLANINI_YENILE'
        : 'DERS_PLANINI_UYGULA');
    }

    try {
      const response = await axios.post(API_ENDPOINTS.ADMIN_AUTO_ASSIGN_COURSES, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setUploadResult(response.data);
      if (response.data.success && mode === 'apply') {
        setSelectedFile(null);
      }
    } catch (error) {
      setUploadResult({
        success: false,
        error: error.response?.data?.error || 'Dosya yüklenirken hata oluştu.'
      });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="akademisyen-tanimla-container">
      <h2>Yeni Dönem Ders Planı ve İzlence Eşleştirme</h2>
      
      <div style={{ marginBottom: '24px' }}>
        <p style={{ color: '#374151', lineHeight: '1.6', marginBottom: '12px' }}>
          Yeni dönemin ders planı okunur. Aynı <strong>Bölüm + Ders Kodu</strong> önceki dönemde
          varsa izlencesi taşınır; yeni dersler izlencesiz açılır.
        </p>
        <div style={{ 
          background: '#f0f4f8', 
          padding: '16px', 
          borderRadius: '8px', 
          border: '1px solid #dbe2ea',
          marginBottom: '16px'
        }}>
          <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: '#1a2634' }}>
            Excel Dosyası Formatı:
          </p>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#4b5563' }}>
            <li><strong>Bölüm:</strong> Dersin bağlı olduğu bölüm (eşleştirmenin zorunlu parçasıdır)</li>
            <li><strong>Ders Kodu:</strong> Ders kodunu içeren kolon (örn: BLM113)</li>
            <li><strong>Ders Adı:</strong> Yeni dönem ders adı</li>
            <li><strong>Sorumlu Öğretim Üyesi:</strong> Akademisyen adını içeren kolon (örn: Prof. Dr. YÜKSEL TÜRKÖZ)</li>
          </ul>
          <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
            <strong>Not:</strong> Aynı ders kodu farklı bölümlerdeyse izlenceler kesinlikle ortaklaştırılmaz.
            İlk adım yalnızca önizlemedir; açık onay verilmeden veri değişmez.
          </p>
        </div>
      </div>

      <label style={{ display: 'block', margin: '16px 0', color: '#991b1b' }}>
        <input
          type="checkbox"
          checked={replaceActiveYear}
          onChange={(event) => setReplaceActiveYear(event.target.checked)}
          style={{ marginRight: 8 }}
        />
        Seçili aktif yılın ders planı alanlarını ve akademisyen atamalarını bu Excel ile güncelle.
        Aynı bölüm ve ders koduna sahip derslerin izlence, sınav ve öğrenci verileri korunur.
      </label>

      <div className="framed-upload">
        <div
          className={"upload-area" + (isDragOver ? " drag-over" : "")}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={() => document.getElementById('courseFileInput').click()}
        >
          <input
            id="courseFileInput"
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileSelect}
            style={{display: 'none'}}
          />
          
          {selectedFile ? (
            <div>
              <p style={{color: '#059669', fontWeight: 600}}>✓ Dosya seçildi</p>
              <p style={{color: '#374151'}}>{selectedFile.name}</p>
            </div>
          ) : (
            <div>
              <p style={{color: '#6b7280', marginBottom: 8}}>
                Dosyayı buraya sürükleyin veya tıklayarak seçin
              </p>
              <p style={{color: '#9ca3af', fontSize: 12}}>
                Sadece .xlsx ve .xls dosyaları kabul edilir
              </p>
            </div>
          )}
        </div>
      </div>

      {selectedFile && (
        <button 
          onClick={() => handleUpload('preview')} 
          disabled={isUploading}
          className="akademisyen-btn btn-blue"
        >
          {isUploading ? 'İnceleniyor...' : 'Planı Önizle'}
        </button>
      )}

      {uploadResult && (
        <div style={{ 
          marginTop: '24px', 
          padding: '16px', 
          borderRadius: '8px',
          backgroundColor: uploadResult.success ? '#f0fdf4' : '#fef2f2',
          border: `1px solid ${uploadResult.success ? '#86efac' : '#fecaca'}`
        }}>
          {uploadResult.success ? (
            <div>
              <h3 style={{ color: '#059669', marginTop: 0, marginBottom: '12px' }}>
                {uploadResult.mode === 'applied' ? '✓ Ders Planı Uygulandı' : '✓ Önizleme Hazır'}
              </h3>
              <div style={{ color: '#374151', lineHeight: '1.8' }}>
                {uploadResult.mode?.startsWith('replacement') && <p><strong>İşlem:</strong> Aktif yıl ders planı güncellenecek; eşleşen derslerin izlence, sınav ve öğrenci verileri korunacak.</p>}
                <p><strong>Kaynak dönem:</strong> {uploadResult.source_year}</p>
                <p><strong>Hedef dönem:</strong> {uploadResult.target_year}</p>
                <p><strong>Excel satırı:</strong> {uploadResult.excel_rows || 0}</p>
                <p><strong>Tekil ders:</strong> {uploadResult.unique_courses || 0}</p>
                {uploadResult.mode?.startsWith('replacement') && (
                  <p><strong>Kimliği ve bağlı verileri korunan mevcut ders:</strong> {uploadResult.preserved_existing_courses || 0}</p>
                )}
                <p><strong>İzlencesi taşınacak:</strong> {uploadResult.matched_syllabi || 0}</p>
                <p><strong>Eski seçmeliden yalnız amaç/içerik bilgisi taşınacak:</strong> {uploadResult.legacy_course_info_matches || 0}</p>
                <p><strong>Tam izlencesi olmadan açılacak:</strong> {uploadResult.new_without_syllabus || 0}</p>
                <p><strong>Hedef bölüm(ler)de yenilenecek mevcut ders:</strong> {uploadResult.target_courses_to_replace || 0}</p>
                {(uploadResult.mode === 'applied' || uploadResult.mode === 'replacement_applied') && (
                  <>
                    <p><strong>Oluşturulan ders:</strong> {uploadResult.created_courses || 0}</p>
                    {uploadResult.removed_courses !== undefined && <p><strong>Kaldırılan eski ders:</strong> {uploadResult.removed_courses}</p>}
                    <p><strong>Aktarılan izlence:</strong> {uploadResult.inherited_syllabi || 0}</p>
                    <p><strong>Eski seçmeliden aktarılan ders bilgisi:</strong> {uploadResult.inherited_legacy_course_info || 0}</p>
                    <p><strong>Akademisyen ataması:</strong> {uploadResult.successful_assignments || 0}</p>
                  </>
                )}
                {uploadResult.unresolved_programs?.length > 0 && (
                  <div style={{ color: '#dc2626', marginTop: 12 }}>
                    <strong>Eşleşmeyen bölümler ({uploadResult.unresolved_programs.length})</strong>
                    <ul>{uploadResult.unresolved_programs.slice(0, 10).map((x, i) => <li key={i}>Satır {x.row}: {x.program}</li>)}</ul>
                  </div>
                )}
                {uploadResult.invalid_rows?.length > 0 && (
                  <div style={{ color: '#dc2626', marginTop: 12 }}>
                    <strong>Geçersiz ders satırları ({uploadResult.invalid_rows.length})</strong>
                    <ul>{uploadResult.invalid_rows.slice(0, 10).map((x, i) => (
                      <li key={i}>Satır {x.row}: {x.program} / {x.course_code} — {(x.reasons || []).join(', ')}</li>
                    ))}</ul>
                  </div>
                )}
                {uploadResult.conflicting_rows?.length > 0 && (
                  <div style={{ color: '#dc2626', marginTop: 12 }}>
                    <strong>Aynı ders kodunda çelişen Excel satırları ({uploadResult.conflicting_rows.length})</strong>
                    <ul>{uploadResult.conflicting_rows.slice(0, 10).map((x, i) => (
                      <li key={i}>Satır {x.first_row} ve {x.row}: {x.program} / {x.course_code} — {(x.fields || []).join(', ')}</li>
                    ))}</ul>
                  </div>
                )}
                {uploadResult.ambiguous_syllabus_sources?.length > 0 && (
                  <div style={{ color: '#dc2626', marginTop: 12 }}>
                    <strong>İzlence kaynağı belirsiz dersler ({uploadResult.ambiguous_syllabus_sources.length})</strong>
                    <p>Önceki yılda aynı program ve normalize ders koduna ait birden fazla ders var. Yanlış izlenceyi taşımamak için işlem durduruldu.</p>
                    <ul>{uploadResult.ambiguous_syllabus_sources.slice(0, 10).map((x, i) => (
                      <li key={i}>{x.program} / {x.course_code} — kaynak kimlikleri: {(x.source_course_ids || []).join(', ')}</li>
                    ))}</ul>
                  </div>
                )}
                {uploadResult.missing_academics?.length > 0 && (
                  <div style={{ color: '#b45309', marginTop: 12 }}>
                    <strong>Bulunamayan akademisyenler ({uploadResult.missing_academics.length})</strong>
                    <ul>{uploadResult.missing_academics.slice(0, 10).map((x, i) => <li key={i}>{x.academician} — {x.program} / {x.course_code}</li>)}</ul>
                  </div>
                )}
                {uploadResult.protected_target_records?.length > 0 && (
                  <div style={{ color: '#dc2626', marginTop: 12 }}>
                    <strong>İşlem güvenlik nedeniyle durduruldu.</strong>
                    <p>Hedef dönemde sınav veya öğrenci verisi bulunuyor; bu kayıtlar silinmeden ders planı yenilenemez.</p>
                  </div>
                )}
                {uploadResult.mode === 'preview' && uploadResult.can_apply && (
                  <button
                    onClick={() => handleUpload('apply')}
                    disabled={isUploading}
                    className="akademisyen-btn btn-blue"
                    style={{ marginTop: 16 }}
                  >
                    {isUploading ? 'Uygulanıyor...' : `${uploadResult.target_year} Dönemine Uygula`}
                  </button>
                )}
                {uploadResult.not_found_courses && uploadResult.not_found_courses.length > 0 && (
                  <div style={{ marginTop: '12px' }}>
                    <p style={{ color: '#dc2626', fontWeight: '600' }}>
                      Bulunamayan Dersler ({uploadResult.not_found_courses.length}):
                    </p>
                    <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                      {uploadResult.not_found_courses.slice(0, 10).map((item, idx) => (
                        <li key={idx} style={{ fontSize: '14px' }}>
                          Satır {item.row}: {item.course_code}
                        </li>
                      ))}
                      {uploadResult.not_found_courses.length > 10 && (
                        <li style={{ fontSize: '14px', fontStyle: 'italic' }}>
                          ... ve {uploadResult.not_found_courses.length - 10} daha
                        </li>
                      )}
                    </ul>
                  </div>
                )}
                {uploadResult.not_found_academics && uploadResult.not_found_academics.length > 0 && (
                  <div style={{ marginTop: '12px' }}>
                    <p style={{ color: '#dc2626', fontWeight: '600' }}>
                      Bulunamayan Akademisyenler ({uploadResult.not_found_academics.length}):
                    </p>
                    <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                      {uploadResult.not_found_academics.slice(0, 10).map((item, idx) => (
                        <li key={idx} style={{ fontSize: '14px' }}>
                          Satır {item.row}: {item.academician} (Ders: {item.course_code})
                        </li>
                      ))}
                      {uploadResult.not_found_academics.length > 10 && (
                        <li style={{ fontSize: '14px', fontStyle: 'italic' }}>
                          ... ve {uploadResult.not_found_academics.length - 10} daha
                        </li>
                      )}
                    </ul>
                  </div>
                )}
                {uploadResult.errors && uploadResult.errors.length > 0 && (
                  <div style={{ marginTop: '12px' }}>
                    <p style={{ color: '#dc2626', fontWeight: '600' }}>
                      Hatalar ({uploadResult.errors.length}):
                    </p>
                    <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
                      {uploadResult.errors.slice(0, 5).map((item, idx) => (
                        <li key={idx} style={{ fontSize: '14px' }}>
                          {item.error}
                        </li>
                      ))}
                      {uploadResult.errors.length > 5 && (
                        <li style={{ fontSize: '14px', fontStyle: 'italic' }}>
                          ... ve {uploadResult.errors.length - 5} hata daha
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div>
              <h3 style={{ color: '#dc2626', marginTop: 0, marginBottom: '12px' }}>
                ✗ İşlem Başarısız
              </h3>
              <p style={{ color: '#374151' }}>
                {uploadResult.error || 'Bilinmeyen bir hata oluştu.'}
              </p>
              {uploadResult.details && (
                <details style={{ marginTop: '12px' }}>
                  <summary style={{ cursor: 'pointer', color: '#6b7280', fontSize: '14px' }}>
                    Detaylı Hata Bilgisi
                  </summary>
                  <pre style={{ 
                    marginTop: '8px', 
                    padding: '12px', 
                    background: '#f9fafb', 
                    borderRadius: '4px',
                    fontSize: '12px',
                    overflow: 'auto',
                    maxHeight: '200px'
                  }}>
                    {uploadResult.details}
                  </pre>
                </details>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AutoAssignCourses;
